"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RichWise_Website_API.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfPartnerPriceEditViewModel = instanceOfPartnerPriceEditViewModel;
exports.PartnerPriceEditViewModelFromJSON = PartnerPriceEditViewModelFromJSON;
exports.PartnerPriceEditViewModelFromJSONTyped = PartnerPriceEditViewModelFromJSONTyped;
exports.PartnerPriceEditViewModelToJSON = PartnerPriceEditViewModelToJSON;
exports.PartnerPriceEditViewModelToJSONTyped = PartnerPriceEditViewModelToJSONTyped;
/**
 * Check if a given object implements the PartnerPriceEditViewModel interface.
 */
function instanceOfPartnerPriceEditViewModel(value) {
    if (!('ppoOrgId' in value) || value['ppoOrgId'] === undefined)
        return false;
    if (!('ppoPrice' in value) || value['ppoPrice'] === undefined)
        return false;
    return true;
}
function PartnerPriceEditViewModelFromJSON(json) {
    return PartnerPriceEditViewModelFromJSONTyped(json, false);
}
function PartnerPriceEditViewModelFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'ppoNo': json['ppoNo'] == null ? undefined : json['ppoNo'],
        'ppoOrgId': json['ppoOrgId'],
        'ppoFrameNo': json['ppoFrameNo'] == null ? undefined : json['ppoFrameNo'],
        'ppoPrice': json['ppoPrice'],
        'ppoStatus': json['ppoStatus'] == null ? undefined : json['ppoStatus'],
    };
}
function PartnerPriceEditViewModelToJSON(json) {
    return PartnerPriceEditViewModelToJSONTyped(json, false);
}
function PartnerPriceEditViewModelToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'ppoNo': value['ppoNo'],
        'ppoOrgId': value['ppoOrgId'],
        'ppoFrameNo': value['ppoFrameNo'],
        'ppoPrice': value['ppoPrice'],
        'ppoStatus': value['ppoStatus'],
    };
}
